import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { login } from './api';

const AdminLogin = ({ onSuccess }) => {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(password);
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-4">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-slate-900 border border-slate-800 rounded-xl p-8 shadow-2xl"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-lg bg-blue-600 flex items-center justify-center">
            <Lock className="w-4 h-4" />
          </div>
          <div>
            <div className="text-sm text-slate-400">Keystone</div>
            <div className="text-base font-medium">Admin sign in</div>
          </div>
        </div>
        <label className="block text-xs uppercase tracking-[0.16em] text-slate-400 mb-2">
          Password
        </label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-slate-950 border border-slate-800 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-blue-500"
          autoFocus
          data-testid="admin-login-password"
        />
        {error && (
          <p className="mt-3 text-sm text-red-400" data-testid="admin-login-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={busy}
          className="mt-6 w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-50 transition-colors rounded-md py-2.5 text-sm font-medium"
          data-testid="admin-login-submit"
        >
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
